import { jsx as _jsx } from "react/jsx-runtime";
import { FlexBox } from '@dixa/lib-shared-habla';
import { PrivateMediaPlayer } from 'components/privateMediaPlayer';
import { ConversationMessageEventBox } from '../../messageEventBox/conversationMessageEventBox';
export const ConversationAudioEventGroup = ({ allowDownload, className, events, }) => {
    return (_jsx(ConversationMessageEventBox, Object.assign({ className: className, variant: "audio" }, { children: _jsx(FlexBox, Object.assign({ flexDirection: "column", gap: "250" }, { children: events.map((event) => {
                const src = event.channel === 'pstn_phone'
                    ? event.recording_url
                    : event.voicemail_url;
                return src ? (_jsx(PrivateMediaPlayer, { noControlsStyle: true, mediaFile: { src, type: 'audio' }, controls: { download: allowDownload } }, event.id)) : null;
            }) })) })));
};
